export type Size = "small" | "medium" | "large" | "full";
